import styled from 'styled-components';
import ds from 'designsystem';

/* Disable ESlint rule for this file */
/* eslint react/destructuring-assignment: "off" */

const HTMLModifiableBackground = styled.div`
    width: 100%;
    position: relative;
    background-color: ${({ color }) => (color || ds.brand('white'))};
    overflow: ${({ overflow }) => (overflow || 'hidden')};
    
${({ htmlModifiers }) => {
    if (htmlModifiers) {
      let css = '';
      htmlModifiers.forEach((htmlModifier) => {
        css += `${htmlModifier.property}:${ htmlModifier.value};`;
      });
      return css;
    }
    return '';
  }
}
`;

export default HTMLModifiableBackground;



// WEBPACK FOOTER //
// ./src/blocks/HTMLModifableBackground/HTMLModifiableBackground.jsx